import React, { useEffect, useState, useContext } from "react";
import Footer10 from "../shared/Footer10";
import Navbar10 from "../shared/Navbar10";
import Sidebar10 from "../shared/Sidebar10";
import { useNavigate, useLocation } from "react-router-dom";
import { setSessionData, getSessionData } from "../../cache";
import Swal from "sweetalert2";
import Select from "react-select";
import "react-toastify/dist/ReactToastify.css";
import config from "../../config";
import { ContextBoard } from "../../context/ContextBoard";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

function CorrectionRegular() {
  const {
    setCandidateid10,
    setCastecode10,
    setDivyangcode10,
    candidateid10,
    mode10,
    setMode10,
    setDocverify,
    class10regulardata,
  } = useContext(ContextBoard);
  const Navigate = useNavigate();
  const location = useLocation();
  const navigate = useNavigate();

  const [candidateData, setCandidateData] = useState(
    location.state?.candidateData || {}
  );

  useEffect(() => {
    if (!class10regulardata) {
      navigate("/class-x-correct-student");
    }
  }, [navigate]);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const [loading, setLoading] = useState(true);
  const [blockList, setBlockList] = useState([]);
  const [casteListnew, setCasteListnew] = useState([]);
  const [districtList, setDistrictList] = useState([]);
  const [divyangList, setDivyangList] = useState([]);
  const [mediumList, setMediumList] = useState([]);
  const [religionList, setReligionList] = useState([]);
  const [stateList, setStateList] = useState([]);
  const [language1_2new, setLanguage1_2new] = useState([]);
  const [candidateID, setCandidateID] = useState("");

  const [additional, setAdditional] = useState([]);
  const [compulsary, setCompulsary] = useState([]);
  const [compulsory_one, setCompulsoryOne] = useState("");
  const [compulsory_two, setCompulsoryTwo] = useState("");
  const [compulsory_three, setCompulsoryThree] = useState("");

  const [lang1, setLang1] = useState("");
  const [lang2, setLang2] = useState("");
  const [addisubj, setAddisubj] = useState("");

  const [errors, setErrors] = useState({});
  const [isPreviewed, setIsPreviewed] = useState(false);
  const [isAgreed, setIsAgreed] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);

  const [finaledit, setFinaledit] = useState(false);

  const [formData, setFormData] = useState({
    passingyear: "",
    roll_code: "",
    roll_number: "",
    registration_number: "",
    candidate_name: "",
    gender: "",
    date_of_birth: "",
    fathers_name: "",
    mothers_name: "",
    religion: "",
    nationality: "Indian",
    aadhaar_no: "",
    divyang_val: "",
    caste_val: "",
    area: "",
    state_val: "",
    district_val: "",
    block_val: "",
    address_val: "",
    pin_no: "",
    contact_no: "",
    email_id: "",
    category_choice: "",
    board_name: "JAC",
    examination_medium: "",
    language_one: "",
    language_two: "",
    compulsory_one: "",
    compulsory_two: "",
    compulsory_three: "",
    additional_subject: "",
    apaar_id: "",
    pen_no: "",
    language_one_name: "",
    language_two_name: "",
    compulsory_one_name: "",
    compulsory_two_name: "",
    compulsory_three_name: "",
    additional_subject_name: "",
  });

  useEffect(() => {
    if (mode10 === "edit") {
      setFinaledit(true);
      setIsEditMode(true);
      setIsPreviewed(true);
    }
    if (!candidateData) return;
    // 🔹 Read encrypted lists from sessionStorage
    const blockList = getSessionData("blockList") || [];
    const casteList = getSessionData("casteList") || [];
    const districtList = getSessionData("districtList") || [];
    const divyangList = getSessionData("divyangList") || [];
    const mediumList = getSessionData("mediumList") || [];
    const religionList = getSessionData("religionList") || [];
    const stateList = getSessionData("stateList") || [];
    const language1_2 = getSessionData("language1_2") || [];
    const additional = getSessionData("additional") || [];
    const compulsary = getSessionData("compulsary") || [];
    const compulsory_one = getSessionData("compulsory_one") || [];
    const compulsory_two = getSessionData("compulsory_two") || [];
    const compulsory_three = getSessionData("compulsory_three") || [];
    setBlockList(Array.isArray(blockList) ? blockList : []);
    setCasteListnew(Array.isArray(casteList) ? casteList : []);
    setDistrictList(Array.isArray(districtList) ? districtList : []);
    setDivyangList(Array.isArray(divyangList) ? divyangList : []);
    setMediumList(Array.isArray(mediumList) ? mediumList : []);
    setReligionList(Array.isArray(religionList) ? religionList : []);
    setStateList(Array.isArray(stateList) ? stateList : []);
    setLanguage1_2new(Array.isArray(language1_2) ? language1_2 : []);
    setAdditional(Array.isArray(additional) ? additional : []);
    setCompulsary(Array.isArray(compulsary) ? compulsary : []);
    setCompulsoryOne(compulsory_one ? compulsory_one : []);
    setCompulsoryTwo(compulsory_two ? compulsory_two : []);
    setCompulsoryThree(compulsory_three ? compulsory_three : []);

    // 🔹 Set common student details
    setFormData((prev) => ({
      ...prev,
      passingyear: candidateData.cL_9_EXAM_YEAR || "",
      roll_code: sessionStorage.getItem("schoolCode"),
      roll_number: candidateData.rolL_NO || "",
      registration_number: candidateData.registratioN_ID_CL_9 || "",
      candidate_name: candidateData.candidatE_NAME || "",
      gender: candidateData.gender || "",
      date_of_birth: candidateData.dob || "",
      fathers_name: candidateData.fatheR_NAME || "",
      mothers_name: candidateData.motheR_NAME || "",
      religion: candidateData.religion || "",
      nationality: candidateData.nationality || "",
      aadhaar_no: candidateData.aadhaR_CARD || "",
      divyang_val: candidateData.divyang || "",
      caste_val: candidateData.caste || "",
      area: candidateData.area || "",
      state_val: candidateData.state || "",
      district_val: candidateData.districT_ID || "",
      block_val: candidateData.block || "",
      address_val: candidateData.address || "",
      pin_no: candidateData.pincode || "",
      contact_no: candidateData.contacT_NO || "",
      email_id: candidateData.emaiL_ID || "",
      category_choice: candidateData.studenT_EXAM_SUB_CATEGORY || "",
      board_name: candidateData.board || "",
      examination_medium: candidateData.mediuM_OF_EXAM || "",
      language_one: candidateData.suB_1 || "",
      language_two: candidateData.suB_2 || "",
      compulsory_one: candidateData.suB_3 || "",
      compulsory_two: candidateData.suB_4 || "",
      compulsory_three: candidateData.suB_5 || "",
      additional_subject: candidateData.suB_6 || "",
      apaar_id: candidateData.apaaR_ID || "",
      pen_no: candidateData.peN_NO || "",
      language_one_name: candidateData.subjecT_NAME1 || "",
      language_two_name: candidateData.subjecT_NAME2 || "",
      compulsory_one_name: candidateData.subjecT_NAME3 || "",
      compulsory_two_name: candidateData.subjecT_NAME4 || "",
      compulsory_three_name: candidateData.subjecT_NAME5 || "",
      additional_subject_name: candidateData.subjecT_NAME6 || "",
    }));
    setCandidateID(candidateData.candidatE_ID || "");
    setAddisubj(candidateData.suB_6 || "");
    setLang1(candidateData.suB_1 || "");
    setLang2(candidateData.suB_2 || "");
    setLoading(false);
  }, []);

  const handleChange = (e) => {
    const { name, value = "" } = e.target;

    let formattedValue = value;

    if (name === "religion") {
      formattedValue = value;
    }

    setFormData((prev) => ({
      ...prev,
      [name]: formattedValue,
    }));

    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };
  const getFilteredSubjectOptions = (excludeCodes = [], mode = "main") =>
    getFilteredSubjects(excludeCodes, mode).map((subj) => ({
      value: subj.subjecT_ID,
      label: `${subj.subjecT_NAME} (${subj.subjecT_ID})` || "",
    }));
  // const getFilteredSubjects = (excludeCodes = [], mode = "main") => {
  //   const hasHN = excludeCodes.includes("HNA") || excludeCodes.includes("HNB");

  //   const source = mode === "additional" ? additional : language1_2new;

  //   return source.filter((subj) => {
  //     const subjId = subj.subjecT_ID;

  //     if (subj.regulaR_HIDE === "YES") return false;

  //     if (hasHN && (subjId === "HNA" || subjId === "HNB")) return false;
  //     if (excludeCodes.includes(subjId)) return false;

  //     return true;
  //   });
  // };
  const getFilteredSubjects = (excludeCodes = [], mode = "main") => {
    // ✅ Normalize to array of strings only
    const safeExcludeCodes = new Set(
      (Array.isArray(excludeCodes) ? excludeCodes : [excludeCodes]).filter(
        (code) => typeof code === "string" && code.trim() !== ""
      )
    );

    const hasHN = safeExcludeCodes.has("HNA") || safeExcludeCodes.has("HNB");

    const source = mode === "additional" ? additional : language1_2new;

    return source.filter((subj) => {
      const subjId = subj.subjecT_ID;

      // Hide regular-hidden subjects
      if (subj.regulaR_HIDE === "YES") return false;

      // Hide HN pair strictly
      if (hasHN && (subjId === "HNA" || subjId === "HNB")) return false;

      // ✅ STRICT PERFECT MATCH ONLY
      return !safeExcludeCodes.has(subjId);
    });
  };

  const handlePreview = async () => {
    setIsAgreed(false);
    setLoading(true);
    const trimmed = (val) => (val || "").trim();

    const rawPen = formData.pen_no?.trim();
    if (rawPen) {
      const penno = rawPen.replace(/\s/g, "");
      if (penno && penno.length >= 11 && penno.length <= 14) {
        const token = sessionStorage.getItem("tokenclassx");
        try {
          const response = await fetch(
            `${config.API_BASE_URL}/PENNoCheckingStudentData_CL10`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              },
              body: JSON.stringify({
                candidatE_ID: candidateData.candidatE_ID || "",
                peN_NO: penno,
              }),
            }
          );
          const result = await response.json();

          if (result.status === 404) {
            Swal.fire({
              icon: "warning",
              title: "PEN No. Already Exists.",
            });
            setFormData((prev) => ({
              ...prev,
              pen_no: "",
            }));
            setLoading(false);
            return;
          }
        } catch (error) {
          console.error("Error verifying PEN No.", error);
          setLoading(false);
          return;
        }
      }
    }

    const newErrors = {};
    if (!formData.gender) {
      newErrors.gender = "Gender is required.";
    }
    // if (!formData.religion) {
    //   newErrors.religion = "Religion is required.";
    // }
    if (!formData.divyang_val) {
      newErrors.divyang_val = "Divyang selection is required.";
    }

    if (!formData.caste_val) {
      newErrors.caste_val = "Caste is required.";
    }
    if (!formData.language_one) {
      newErrors.language_one = "Language I subject is required.";
    }

    if (!formData.language_two) {
      newErrors.language_two = "Language II subject is required.";
    }

    if (formData.language_one && formData.language_two) {
      const validLangs = ["HNA", "HNB", "ENG"];
      const lang1Valid = validLangs.includes(formData.language_one);
      const lang2Valid = validLangs.includes(formData.language_two);

      if (!lang1Valid && !lang2Valid) {
        Swal.fire(
          "Error",
          "Amongst Hindi - A, Hindi - B & English one subject has to be taken as Language I or Language II.",
          "error"
        );
        setLang1("");
        setLang2("");
        setFormData((prev) => ({
          ...prev,
          language_one: "",
          language_two: "",
        }));
        newErrors.language_one = "Language I subject is required.";
        newErrors.language_two = "Language II subject is required.";
      }
    }
    if (!formData.additional_subject) {
      newErrors.additional_subject = "Additional subject is required.";
    }
    if (!trimmed(formData.pen_no)) {
      newErrors.pen_no = "PEN No. is required.";
    } else if (!/^\d{11,14}$/.test(formData.pen_no)) {
      newErrors.pen_no = "PEN No. must be between 11 to 14 digits.";
    }
    if (!/^\d{12}$/.test(formData.apaar_id) && formData.apaar_id) {
      newErrors.apaar_id = "Apaar ID must be exactly 12 digits.";
    }
    setErrors(newErrors);
    const noErrors = Object.keys(newErrors).length === 0;

    if (!noErrors) {
      const firstErrorKey = Object.keys(newErrors)[0];
      const firstErrorElement = document.querySelector(
        `[name="${firstErrorKey}"]`
      );
      if (firstErrorElement) {
        firstErrorElement.focus();
      }
    } else {
      window.scrollTo({ top: 0, behavior: "smooth" });
      setIsPreviewed(true);
    }
    setLoading(false);
  };
  const handleButtonClick = () => {
    // const isEditMode = mode10;
    // if (isEditMode === "edit") {
    handleEditSubmit();
    // } else {
    //   handleSubmit();
    // }
  };
  const handleSubmit = async () => {
    const token = sessionStorage.getItem("tokenclassx");

    // e.preventDefault();
    if (!isAgreed) {
      await Swal.fire({
        icon: "warning",
        title: "Please Agree",
        text: "You must agree before submitting the form.",
      });
      return;
    }
    const subjects = [
      formData.language_one,
      formData.language_two,
      formData.compulsory_one,
      formData.compulsory_two,
      formData.compulsory_three,
      formData.additional_subject,
    ];
    const uniqueSubjects = new Set(subjects.filter(Boolean));
    if (uniqueSubjects.size !== subjects.length) {
      await Swal.fire({
        icon: "warning",
        title: "Duplicate Subjects",
        text: "Each subject must be unique. Please check your subject selections.",
      });
      return;
    }
    const payload = {
      studenT_EXAM_SUB_CATEGORY: formData.category_choice || "",
      registratioN_SESSION: candidateData.sessioN_CODE || "",
      registratioN_NO: formData.registration_number || "",
      studenT_EXAM_CATEGORY: candidateData.studenT_EXAM_CATEGORY || "",
      candidatE_CODE: candidateData.candidatE_ID || "",
      candidatE_NAME: formData.candidate_name || "",
      gender: formData.gender || "",
      dob: candidateData.dob || "",
      fatheR_NAME: formData.fathers_name || "",
      motheR_NAME: formData.mothers_name || "",
      religion: formData.religion || "",
      aadhaR_CARD: candidateData.aadhaR_CARD || "",
      divyang: formData.divyang_val || "",
      cast: formData.caste_val || "",
      contacT_NO: candidateData.contacT_NO || "",
      emaiL_ID: candidateData.emaiL_ID || "",
      area: candidateData.area || "",
      state: candidateData.state || "",
      districT_ID: candidateData.districT_ID || "",
      block: candidateData.block || "",
      address: candidateData.address || "",
      pincode: candidateData.pincode || "",
      clasS_ROLL_NO: formData.roll_number || "",
      section: candidateData.section || "",
      mediuM_OF_EXAM: candidateData.mediuM_OF_EXAM || "",
      apaaR_ID: formData.apaar_id || "",
      nationality: candidateData.nationality || "",
      subjecT_1_CODE: candidateData.suB_1 || "",
      subjecT_2_CODE: candidateData.suB_2 || "",
      subjecT_3_CODE: candidateData.suB_3 || "",
      subjecT_4_CODE: candidateData.suB_4 || "",
      subjecT_5_CODE: candidateData.suB_5 || "",
      subjecT_6_CODE: candidateData.suB_6 || "",
      SCHOOL_DIST_CODE: sessionStorage.getItem("district") || "",
      peN_NO: formData.pen_no || "",
      BOARD_NAME: candidateData.board || "",
      PASSING_YEAR: formData.passingyear || "",
    };
    // console.log(payload);
    try {
      const response = await fetch(
        `${config.API_BASE_URL}/InsertDataStudentRegistration_CL10`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(payload),
        }
      );

      const data = await response.json();

      setCandidateid10(data.data || "");
      setCastecode10(formData.caste_val || "");
      setDivyangcode10(formData.divyang_val || "");
      if (response.ok) {
        await Swal.fire({
          icon: "success",
          title: "Success",
          text: "Your data added successfully",
          confirmButtonText: "OK",
        });
        setCandidateData({});
        if (finaledit === false) {
          setDocverify(true);
          navigate("/class-x-upload-document");
        } else {
          navigate("/class-x-upload-document");
        }
        // window.location.reload();
      } else {
        await Swal.fire({
          icon: "error",
          title: "Submission Failed",
          text: data.message || "Something went wrong. Please try again.",
        });
      }
    } catch (error) {
      console.error("API Error:", error);
      await Swal.fire({
        icon: "error",
        title: "Network Error",
        text: "Please check your internet connection and try again.",
      });
    }
  };
  const handleEditSubmit = async () => {
    const token = sessionStorage.getItem("tokenclassx");

    // e.preventDefault();
    if (!isAgreed) {
      await Swal.fire({
        icon: "warning",
        title: "Please Agree",
        text: "You must agree before submitting the form.",
      });
      return;
    }
    const payload = {
      candidatE_CODE: candidateData.candidatE_ID || "",
      refferencE_NO: candidateData.registratioN_ID_CL_9,
      subjecT_1_CODE: formData.language_one,
      subjecT_2_CODE: formData.language_two,
      subjecT_3_CODE: formData.compulsory_one,
      subjecT_4_CODE: formData.compulsory_two,
      subjecT_5_CODE: formData.compulsory_three,
      subjecT_6_CODE: formData.additional_subject,
      divyang: formData.divyang_val || "",
      religion: formData.religion || "",
      apaaR_ID: formData.apaar_id || "",
      peN_NO: formData.pen_no || "",
    };
    try {
      const response = await fetch(
        `${config.API_BASE_URL}/AdminUpdateRegularStudentCorrection_CL10`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(payload),
        }
      );

      const data = await response.json();

      setCandidateid10(candidateData.candidatE_ID || "");
      setCastecode10(formData.caste_val || "");
      setDivyangcode10(formData.divyang_val || "");
      if (response.ok) {
        await Swal.fire({
          icon: "success",
          title: "Success",
          text: "Your data Updated successfully",
          confirmButtonText: "OK",
        });
        setCandidateData({});
        // if (finaledit === false) {
        setDocverify(false);
        setMode10("edit");
        navigate("/class-x-upload-document");
        // } else {
        //   navigate("/class-x-upload-document");
        // }

        // window.location.reload();
      } else {
        await Swal.fire({
          icon: "error",
          title: "Submission Failed",
          text: data.message || "Something went wrong. Please try again.",
        });
      }
    } catch (error) {
      console.error("API Error:", error);
      await Swal.fire({
        icon: "error",
        title: "Network Error",
        text: "Please check your internet connection and try again.",
      });
    }
  };
  const handlePenBlur = async () => {
    const rawPen = formData.pen_no?.trim();
    if (rawPen) {
      const penno = rawPen.replace(/\s/g, "");

      if (!penno || penno.length < 11 || penno.length > 14) return;

      const token = sessionStorage.getItem("tokenclassx");

      try {
        const response = await fetch(
          `${config.API_BASE_URL}/PENNoCheckingStudentData_CL10`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({
              candidatE_ID: candidateData.candidatE_ID || "",
              peN_NO: penno,
            }),
          }
        );

        const result = await response.json();

        if (result.status === 404) {
          Swal.fire({
            icon: "warning",
            title: "PEN(Permanent Education Number) No. Already Exists.",
            // text: "Aadhaar Number Already Exists.",
          });
          setFormData((prev) => ({
            ...prev,
            pen_no: "",
          }));

          return;
        }
        // console.log("Aadhaar verification result:", result);
      } catch (error) {
        console.error("Error verifying PEN No.", error);
      }
    }
  };

  const handleEditClick = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to edit this profile?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, Edit",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        setIsEditMode(false);
        setIsPreviewed(false);
      }
    });
  };

  const handleContinueClick = async () => {
    if (!isAgreed) {
      await Swal.fire({
        icon: "warning",
        title: "Please Agree",
        text: "You must agree before submitting the form.",
      });
      return;
    }
    setCandidateid10(candidateid10 || "");
    setCastecode10(formData.caste_val || "");
    setDivyangcode10(formData.divyang_val || "");
    if (isEditMode === false) {
      finaledit(true);
      navigate("/class-x-upload-document");
    } else {
      navigate("/class-x-upload-document");
    }
  };
  return (
    <>
      {loading && (
        <div className="custom-loader-container">
          <div className="custom-loader"></div>
        </div>
      )}
      <div class="container-scroller">
        <Navbar10 />
        <div class="container-fluid page-body-wrapper">
          <Sidebar10 />
          <div class="main-panel">
            <div class="content-wrapper">
              <div class="row">
                <div class="col-md-12 mb-1">
                  <section class="content-header">
                    <h1>
                      <i class="fa fa-user-plus"></i>&nbsp; Correct Student
                      (Student Correction Page for Board Examination)
                    </h1>
                    <ol class="breadcrumb">
                      <li>
                        <a
                          href="#"
                          onClick={(e) => {
                            e.preventDefault();
                            navigate("/class-x-dashboard");
                          }}
                        >
                          <svg
                            stroke="currentColor"
                            fill="currentColor"
                            stroke-width="0"
                            viewBox="0 0 512 512"
                            height="1em"
                            width="1em"
                            xmlns="http://www.w3.org/2000/svg"
                            style={{ marginTop: "-4px" }}
                          >
                            <path d="M256 64C132.3 64 32 164.2 32 287.9c0 57 21.3 109 56.3 148.5 1.1 1.2 2.1 2.4 3.2 3.5C96.3 445 103 448 110 448c7.1 0 13.8-3 18.6-8.2 31.6-34.4 77-55.9 127.4-55.9s95.8 21.6 127.4 55.9c4.8 5.2 11.5 8.2 18.6 8.2 7 0 13.7-2.9 18.5-8.1 1.1-1.2 2.1-2.3 3.2-3.5 35-39.5 56.3-91.5 56.3-148.5C480 164.2 379.7 64 256 64zm-14 45.9c0-7.7 6.3-14 14-14s14 6.3 14 14v36c0 7.7-6.3 14-14 14s-14-6.3-14-14v-36zm-128 192H78c-7.7 0-14-6.3-14-14s6.3-14 14-14h36c7.7 0 14 6.3 14 14s-6.3 14-14 14zm51.5-104.5c-5.4 5.4-14.4 5.4-19.8 0L120.2 172c-5.4-5.4-5.4-14.4 0-19.8s14.4-5.4 19.8 0l25.5 25.5c5.4 5.4 5.4 14.3 0 19.7zm160.6 34.5l-47.5 75.5c-1.9 2.6-4.3 5.1-7 7-13.5 9.7-32.3 6.5-42-7s-6.5-32.3 7-42l75.5-47.5c3.4-2.4 8.1-2.5 11.7 0 4.5 3.2 5.5 9.5 2.3 14zm40.2-34.5c-5.4 5.4-14.4 5.4-19.8 0s-5.4-14.4 0-19.8l25.5-25.5c5.4-5.4 14.4-5.4 19.8 0s5.4 14.4 0 19.8l-25.5 25.5zM434 301.9h-36c-7.7 0-14-6.3-14-14s6.3-14 14-14h36c7.7 0 14 6.3 14 14s-6.3 14-14 14z"></path>
                          </svg>{" "}
                          Home&nbsp;
                        </a>
                      </li>
                      <li class="active"> Correct Student</li>
                    </ol>
                  </section>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12 stretch-card mb-4">
                  <div class="card">
                    <div class="card-header">
                      <h5 class="mb-0 p-2">Class IX Passing Details</h5>
                    </div>
                    <div class="card-body">
                      <div
                        class="row d-flex"
                        style={{ justifyContent: "center" }}
                      >
                        <div class="col-md-10 py-3">
                          <div class="row">
                            <label class="col-md-3">Passing Year :</label>
                            <div class="col-md-2">
                              <input
                                type="text"
                                class="form-control form-control-xs"
                                value={formData.passingyear}
                                disabled
                              />
                            </div>
                          </div>

                          <div class="row mt-3">
                            <label class="col-md-3">Roll Code:</label>
                            <div class="col-md-3">
                              <input
                                class="form-control form-control-xs number"
                                id="roll_code"
                                required=""
                                value={formData.roll_code}
                                disabled
                              />
                            </div>
                          </div>
                          <div class="row mt-3">
                            <label class="col-md-3">Roll Number:</label>
                            <div class="col-md-3">
                              <input
                                class="form-control form-control-xs number"
                                id="roll_number"
                                required=""
                                value={formData.roll_number}
                                disabled
                              />
                            </div>
                          </div>
                          <div class="row mt-3">
                            <label class="col-md-3">
                              Registration Number :
                            </label>
                            <div class="col-md-2">
                              <input
                                class="form-control form-control-xs number"
                                id="registration_number1"
                                required=""
                                maxlength="5"
                                minlength="5"
                                value={
                                  formData.registration_number.split("-")[0]
                                }
                                disabled
                              />
                            </div>
                            <div class="col-md-2">
                              <input
                                class="form-control form-control-xs number"
                                id="registration_number2"
                                required=""
                                maxlength="5"
                                minlength="5"
                                value={
                                  formData.registration_number.split("-")[1]
                                }
                                disabled
                              />
                            </div>
                            <div class="col-md-2">
                              <input
                                class="form-control form-control-xs number"
                                id="registration_number3"
                                required=""
                                maxlength="2"
                                minlength="2"
                                value={
                                  formData.registration_number.split("-")[2]
                                }
                                disabled
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-12 mb-4">
                  <div class="card">
                    <div class="card-header">
                      <h4 class="mb-0 p-2">Student Details</h4>
                    </div>
                    <div class="card-body">
                      <div class="row">
                        <div
                          class="col-lg-9"
                          style={{ borderRight: "1px solid #CED4DA" }}
                        >
                          <div class="row">
                            <div class="col-lg-6 col-m-6">
                              <div class="form-group  mb-3">
                                <label>Name of Student</label>
                                <div class="input-group">
                                  <input
                                    type="text"
                                    disabled
                                    class="form-control form-control-sm disable count"
                                    name="candidate_name"
                                    value={formData.candidate_name}
                                  />
                                </div>
                              </div>
                            </div>
                            <div class="col-lg-3 col-m-6">
                              <div class="form-group  mb-3">
                                <label>Gender</label>
                                <select
                                  className="form-select form-select-sm"
                                  name="gender"
                                  disabled
                                  value={formData.gender?.toUpperCase()}
                                >
                                  <option value="">Select</option>
                                  <option value="MALE">MALE</option>
                                  <option value="FEMALE">FEMALE</option>
                                  <option value="TRANSGENDER">
                                    TRANSGENDER
                                  </option>
                                </select>
                              </div>
                            </div>
                            <div class="col-lg-3 col-m-6">
                              <div class="form-group  mb-3">
                                <label>Date of Birth</label>
                                {/* <input
                                  type="date"
                                  name="birth_date"
                                  id="birth_date"
                                  disabled
                                  class="form-control form-control-sm disable"
                                  value={formData.date_of_birth
                                    .split("-")
                                    .reverse()
                                    .join("-")}
                                /> */}
                                <DatePicker
                                  id="birth_date"
                                  name="birth_date"
                                  selected={
                                    formData.date_of_birth
                                      ? (() => {
                                          const [dd, mm, yyyy] =
                                            formData.date_of_birth.split("-");
                                          return new Date(
                                            Number(yyyy),
                                            Number(mm) - 1,
                                            Number(dd)
                                          );
                                        })()
                                      : null
                                  }
                                  onChange={(date) => {
                                    if (date) {
                                      const dd = String(
                                        date.getDate()
                                      ).padStart(2, "0");
                                      const mm = String(
                                        date.getMonth() + 1
                                      ).padStart(2, "0");
                                      const yyyy = date.getFullYear();

                                      setFormData({
                                        ...formData,
                                        date_of_birth: `${dd}-${mm}-${yyyy}`, // store dd-mm-yyyy
                                      });
                                    } else {
                                      setFormData({
                                        ...formData,
                                        date_of_birth: "",
                                      });
                                    }
                                  }}
                                  dateFormat="dd-MM-yyyy"
                                  className="form-control form-control-sm disable"
                                  placeholderText="dd-mm-yyyy"
                                  disabled
                                  onKeyDown={(e) => e.preventDefault()}
                                  // maxDate={new Date("2013-03-01")}
                                  showYearDropdown
                                  scrollableYearDropdown
                                  yearDropdownItemNumber={60}
                                />
                              </div>
                            </div>
                            <div class="col-lg-4 col-md-4">
                              <div class="form-group  mb-3">
                                <label>Father’s Name</label>
                                <div class="input-group">
                                  <input
                                    type="text"
                                    name="father_name"
                                    disabled
                                    class="form-control form-control-sm disable count1"
                                    value={formData.fathers_name}
                                  />
                                </div>
                              </div>
                            </div>

                            <div class="col-lg-4 col-md-4">
                              <div class="form-group  mb-3">
                                <label>Mother’s Name</label>
                                <div class="input-group">
                                  <input
                                    type="text"
                                    name="mother_name"
                                    disabled
                                    class="form-control form-control-sm disable count2"
                                    value={formData.mothers_name}
                                  />
                                </div>
                              </div>
                            </div>
                            <div class="col-lg-4 col-md-4">
                              <div class="form-group  mb-3">
                                <label>Religion</label>
                                <div class="input-group">
                                  <select
                                    className="form-select form-select-sm"
                                    name="religion"
                                    id="religion"
                                    value={formData.religion || ""}
                                    onChange={handleChange}
                                    disabled={isPreviewed}
                                  >
                                    <option value="">Select</option>
                                    {religionList.map((religion) => (
                                      <option
                                        key={religion.religioN_ID}
                                        value={religion.religioN_ID}
                                      >
                                        {religion.religioN_NAME}
                                      </option>
                                    ))}
                                  </select>
                                </div>
                                {errors.religion && (
                                  <div className="text-danger mt-1 small">
                                    {errors.religion}
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-lg-3 col-md-12">
                          <div class="form-group mb-3">
                            <label>
                              Divyang <span class="text-danger">*</span>
                            </label>

                            <select
                              className={`form-select form-select-sm ${
                                errors.divyang_val ? "is-invalid" : ""
                              }`}
                              id="divyang_val"
                              name="divyang_val"
                              value={formData.divyang_val}
                              onChange={handleChange}
                              disabled={isPreviewed}
                            >
                              <option value="">Select</option>
                              {divyangList.map((divyang) => (
                                <option
                                  key={divyang.divyanG_ID}
                                  value={divyang.divyanG_ID}
                                >
                                  {divyang.divyanG_NAME}
                                </option>
                              ))}
                            </select>
                            {errors.divyang_val && (
                              <div className="text-danger mt-1 small">
                                {errors.divyang_val}
                              </div>
                            )}
                          </div>
                          <div class="form-group mb-3">
                            <label>
                              Caste <span class="text-danger">*</span>
                            </label>
                            <select
                              className={`form-select form-select-sm ${
                                errors.caste_val ? "is-invalid" : ""
                              }`}
                              name="caste_val"
                              id="caste_val"
                              value={formData.caste_val}
                              onChange={handleChange}
                              disabled
                            >
                              <option value="">Choose Caste</option>
                              {casteListnew.map((caste) => (
                                <option
                                  key={caste.castE_ID}
                                  value={caste.castE_ID}
                                >
                                  {caste.castE_NAME}
                                </option>
                              ))}
                            </select>
                            {errors.caste_val && (
                              <div className="text-danger mt-1 small">
                                {errors.caste_val}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-9 mb-4 stretch-card">
                  <div class="card">
                    <div class="card-header">
                      <h4 class="mb-0 p-2">Educational Details</h4>
                    </div>
                    <div class="card-body">
                      <div class="row">
                        <div class="form-group">
                          <div class="row">
                            <div class="col-lg-4 col-m-4">
                              <div class="form-group mb-3">
                                <label>Category Choice</label>

                                <input
                                  type="text"
                                  disabled
                                  class="form-control form-control-sm"
                                  value={formData.category_choice}
                                />
                              </div>
                            </div>
                            <div class="col-lg-4 col-m-4">
                              <div class="form-group mb-3">
                                <label>Board Name</label>
                                <input
                                  type="text"
                                  disabled
                                  class="form-control form-control-sm"
                                  name="board_name"
                                  id="board_name"
                                  value={formData.board_name}
                                />
                              </div>
                            </div>
                            <div class="col-lg-4 col-m-4">
                              <div class="form-group mb-3">
                                <label>Medium of Examination</label>
                                <select
                                  className={`form-select form-select-sm  ${
                                    errors.examination_medium
                                      ? "is-invalid"
                                      : ""
                                  }`}
                                  name="examination_medium"
                                  value={formData.examination_medium}
                                  onChange={handleChange}
                                  disabled
                                >
                                  <option value="">
                                    Choose Medium of Examination
                                  </option>
                                  {mediumList.map((medium) => (
                                    <option
                                      key={medium.mediuM_ID}
                                      value={medium.mediuM_ID}
                                    >
                                      {medium.mediuM_NAME}
                                    </option>
                                  ))}
                                </select>
                                {errors.examination_medium && (
                                  <div className="text-danger mt-1 small">
                                    {errors.examination_medium}
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div className="col-lg-4 col-m-4">
                              <div className="form-group mb-3">
                                <label>
                                  Language I Subject{" "}
                                  <span className="text-danger">*</span>
                                </label>
                                <Select
                                  isSearchable={true}
                                  isClearable={true}
                                  classNamePrefix="react-select"
                                  className={
                                    errors.language_one ? "is-invalid" : ""
                                  }
                                  name="language_one"
                                  isDisabled={isPreviewed}
                                  placeholder="Choose Language I Subject"
                                  value={
                                    getFilteredSubjectOptions(lang2).find(
                                      (opt) => opt.value === lang1
                                    ) || null
                                  }
                                  onChange={(selected) => {
                                    setLang1(selected?.value || "");
                                    setFormData((prev) => ({
                                      ...prev,
                                      language_one: selected?.value || "",
                                    }));
                                    if (errors.language_one) {
                                      setErrors((prev) => ({
                                        ...prev,
                                        language_one: "",
                                      }));
                                    }
                                  }}
                                  options={getFilteredSubjectOptions([
                                    lang2,
                                    addisubj,
                                  ])}
                                />
                                {errors.language_one && (
                                  <div className="text-danger mt-1 small">
                                    {errors.language_one}
                                  </div>
                                )}
                              </div>
                            </div>

                            <div className="col-lg-4 col-m-4">
                              <div className="form-group mb-3">
                                <label>
                                  Language II Subject{" "}
                                  <span className="text-danger">*</span>
                                </label>
                                <Select
                                  isSearchable={true}
                                  isClearable={true}
                                  classNamePrefix="react-select"
                                  className={
                                    errors.language_two ? "is-invalid" : ""
                                  }
                                  name="language_two"
                                  isDisabled={isPreviewed}
                                  placeholder="Choose Language II Subject"
                                  value={
                                    getFilteredSubjectOptions(lang1).find(
                                      (opt) => opt.value === lang2
                                    ) || null
                                  }
                                  onChange={(selected) => {
                                    setLang2(selected?.value || "");
                                    setFormData((prev) => ({
                                      ...prev,
                                      language_two: selected?.value || "",
                                    }));
                                    if (errors.language_two) {
                                      setErrors((prev) => ({
                                        ...prev,
                                        language_two: "",
                                      }));
                                    }
                                  }}
                                  options={getFilteredSubjectOptions([
                                    lang1,
                                    addisubj,
                                  ])}
                                />
                                {errors.language_two && (
                                  <div className="text-danger mt-1 small">
                                    {errors.language_two}
                                  </div>
                                )}
                              </div>
                            </div>

                            <div class="col-lg-4 col-m-4">
                              <div class="form-group mb-3">
                                <label>Compulsory I Subject</label>
                                <input
                                  type="text"
                                  className="form-control form-control-sm"
                                  value={
                                    formData.compulsory_one_name
                                      ? `${formData.compulsory_one_name}${
                                          candidateData.suB_3
                                            ? ` (${candidateData.suB_3})`
                                            : ""
                                        }`
                                      : candidateData.suB_3
                                      ? `${candidateData.suB_3}`
                                      : ""
                                  }
                                  disabled
                                />
                              </div>
                            </div>

                            <div class="col-lg-4 col-m-4">
                              <div class="form-group mb-3">
                                <label>Compulsory II Subject</label>
                                <input
                                  type="text"
                                  className="form-control form-control-sm"
                                  value={
                                    formData.compulsory_two_name
                                      ? `${formData.compulsory_two_name}${
                                          candidateData.suB_4
                                            ? ` (${candidateData.suB_4})`
                                            : ""
                                        }`
                                      : candidateData.suB_4
                                      ? `${candidateData.suB_4}`
                                      : ""
                                  }
                                  disabled
                                />
                              </div>
                            </div>

                            <div class="col-lg-4 col-m-4">
                              <div class="form-group mb-3">
                                <label>Compulsory III Subject</label>
                                <input
                                  type="text"
                                  className="form-control form-control-sm"
                                  value={
                                    formData.compulsory_three_name
                                      ? `${formData.compulsory_three_name}${
                                          candidateData.suB_5
                                            ? ` (${candidateData.suB_5})`
                                            : ""
                                        }`
                                      : candidateData.suB_5
                                      ? `${candidateData.suB_5}`
                                      : ""
                                  }
                                  disabled
                                />
                              </div>
                            </div>

                            <div className="col-lg-4 col-m-4">
                              <div className="form-group mb-3">
                                <label>
                                  Additional Subject{" "}
                                  <span className="text-danger">*</span>
                                </label>
                                <Select
                                  isSearchable={true}
                                  isClearable={true}
                                  classNamePrefix="react-select"
                                  className={
                                    errors.additional_subject
                                      ? "is-invalid"
                                      : ""
                                  }
                                  name="additional_subject"
                                  isDisabled={isPreviewed}
                                  placeholder="Choose Additional Subject"
                                  value={
                                    getFilteredSubjectOptions(
                                      [lang1, lang2],
                                      "additional"
                                    ).find((opt) => opt.value === addisubj) ||
                                    null
                                  }
                                  onChange={(selected) => {
                                    setAddisubj(selected?.value || "");
                                    setFormData((prev) => ({
                                      ...prev,
                                      additional_subject: selected?.value || "",
                                    }));
                                    if (errors.additional_subject) {
                                      setErrors((prev) => ({
                                        ...prev,
                                        additional_subject: "",
                                      }));
                                    }
                                  }}
                                  options={getFilteredSubjectOptions(
                                    [lang1, lang2],
                                    "additional"
                                  )}
                                />

                                {errors.additional_subject && (
                                  <div className="text-danger mt-1 small">
                                    {errors.additional_subject}
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-3 col-md-12 mb-4 stretch-card">
                  <div class="card">
                    <div class="card-header">
                      <h4 class="mb-0 p-2">Other Details</h4>
                    </div>
                    <div class="card-body">
                      <div class="form-group mb-3">
                        <label>
                          Permanent Education Number (PEN){" "}
                          <span class="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          inputMode="numeric"
                          pattern="[0-9]*"
                          id="pen_no"
                          name="pen_no"
                          className={`form-control form-control-sm ${
                            errors.pen_no ? "is-invalid" : ""
                          }`}
                          placeholder="Enter PEN NO"
                          value={formData.pen_no}
                          maxlength="14"
                          onBlur={handlePenBlur}
                          onChange={(e) => {
                            const onlyNums2 = e.target.value.replace(/\D/g, "");
                            handleChange({
                              target: { name: "pen_no", value: onlyNums2 },
                            });
                          }}
                          disabled={isPreviewed}
                        />
                        {errors.pen_no && (
                          <div className="text-danger mt-1 small">
                            {errors.pen_no}
                          </div>
                        )}
                      </div>
                      <div class="form-group mb-3">
                        <label>APAAR ID</label>
                        <input
                          maxlength="12"
                          type="text"
                          inputMode="numeric"
                          pattern="[0-9]*"
                          id="apaar_id"
                          name="apaar_id"
                          className={`form-control form-control-sm ${
                            errors.apaar_id ? "is-invalid" : ""
                          }`}
                          placeholder="Enter APAAR ID"
                          value={formData.apaar_id}
                          onChange={(e) => {
                            const onlyNums = e.target.value.replace(/\D/g, "");
                            handleChange({
                              target: { name: "apaar_id", value: onlyNums },
                            });
                          }}
                          disabled={isPreviewed}
                        />
                        {errors.apaar_id && (
                          <div className="text-danger mt-1 small">
                            {errors.apaar_id}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="card">
                    <div class="card-body">
                      <div className="row">
                        <div className="col-md-8">
                          {isPreviewed && (
                            <h5 style={{ color: "red" }}>
                              <input
                                type="checkbox"
                                checked={isAgreed}
                                onChange={(e) => setIsAgreed(e.target.checked)}
                              />{" "}
                              I AGREE THAT ALL THE INFORMATION GIVEN ABOVE IS
                              CORRECT AS PER MY BEST KNOWLEDGE.
                            </h5>
                          )}
                        </div>
                        <div
                          style={{ textAlign: "right" }}
                          className="col-md-4"
                        >
                          {isEditMode ? (
                            <>
                              <button
                                onClick={handleEditClick}
                                type="button"
                                className="btn btn-primary"
                              >
                                <i className="fa fa-edit me-1"></i> Edit
                              </button>
                              &nbsp;&nbsp;
                              <button
                                type="button"
                                onClick={handleContinueClick}
                                className="btn btn-success me-2"
                              >
                                Next <i className="fa fa-arrow-right me-1"></i>
                              </button>
                            </>
                          ) : isPreviewed ? (
                            <>
                              <button
                                onClick={handleButtonClick}
                                type="button"
                                className="btn btn-primary pull-right"
                              >
                                <i className="fa fa-save me-1"></i>
                                Submit
                              </button>
                              <button
                                type="button"
                                onClick={() => setIsPreviewed(false)}
                                className="btn btn-secondary me-2"
                              >
                                <i className="fa fa-edit me-1"></i> Edit
                              </button>
                            </>
                          ) : (
                            <button
                              type="button"
                              className="btn btn-secondary me-2"
                              onClick={handlePreview}
                            >
                              <i className="fa fa-eye me-1"></i> Preview
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <Footer10 />
          </div>
        </div>
      </div>
    </>
  );
}

export default CorrectionRegular;
